import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TestDiscordServerMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type TestDiscordServerMutation = {
  __typename?: 'Mutation';
  testDiscordServer: {
    __typename?: 'TestIntegrationResult';
    success: boolean;
    message: string;
  };
};

export const TestDiscordServerDocument = gql`
  mutation TestDiscordServer($id: UUID!) {
    testDiscordServer(id: $id) {
      success
      message
    }
  }
`;
export type TestDiscordServerMutationFn = Apollo.MutationFunction<
  TestDiscordServerMutation,
  TestDiscordServerMutationVariables
>;

/**
 * __useTestDiscordServerMutation__
 *
 * To run a mutation, you first call `useTestDiscordServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestDiscordServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testDiscordServerMutation, { data, loading, error }] = useTestDiscordServerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTestDiscordServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TestDiscordServerMutation,
    TestDiscordServerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TestDiscordServerMutation,
    TestDiscordServerMutationVariables
  >(TestDiscordServerDocument, options);
}
export type TestDiscordServerMutationHookResult = ReturnType<
  typeof useTestDiscordServerMutation
>;
export type TestDiscordServerMutationResult =
  Apollo.MutationResult<TestDiscordServerMutation>;
export type TestDiscordServerMutationOptions = Apollo.BaseMutationOptions<
  TestDiscordServerMutation,
  TestDiscordServerMutationVariables
>;
